import { render } from "./WorkEducation.vue?vue&type=template&id=309839fa&scoped=true"
import script from "./WorkEducation.vue?vue&type=script&lang=js"
export * from "./WorkEducation.vue?vue&type=script&lang=js"

import "./WorkEducation.vue?vue&type=style&index=0&id=309839fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309839fa"]])

export default __exports__